import React, { forwardRef, InputHTMLAttributes } from 'react';

import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

import { Icon } from '../Icon';
import { Palette, Radius } from '../Theme';

const useStyles = createUseStyles({
    checkBoxContainer: { position: 'relative', display: 'block', height: 40, width: 40 },
    checkBoxIcon: { position: 'absolute', top: 8, left: 8, pointerEvents: 'none' },
    checkBoxInput: {
        appearance: 'none',
        borderRadius: Radius.x50,
        height: 40,
        width: 40,
        boxSizing: 'border-box',
        margin: 0,
        position: 'relative',
    },
    enabled: {
        cursor: 'pointer',
    },
    disabled: { color: Palette.Fill.x30 },
});

interface CheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
    color?: string;
}

const CheckBox = forwardRef(
    (
        { checked = false, disabled = false, type = 'checkbox', color, ...inputProps }: CheckBoxProps,
        ref: React.Ref<HTMLInputElement>,
    ): JSX.Element => {
        const classes = useStyles();
        const IconElement = Icon[checked ? 'CheckBox' : 'CheckBoxOutlineBlank'];
        const sizedIconElement = (
            <IconElement
                size={'24px'}
                color={
                    checked
                        ? disabled
                            ? Palette.Fill.x30
                            : color
                            ? color
                            : Palette.Fill.x10
                        : disabled
                        ? Palette.Fill.x40
                        : Palette.Fill.x20
                }
            />
        );

        return (
            <span className={classes.checkBoxContainer}>
                <input
                    style={{
                        cursor: disabled ? 'not-allowed' : undefined,
                    }}
                    className={clsx(classes.checkBoxInput, disabled ? classes.disabled : classes.enabled)}
                    ref={ref}
                    type={type}
                    {...inputProps}
                />
                <span className={classes.checkBoxIcon}>{sizedIconElement}</span>
            </span>
        );
    },
);

CheckBox.displayName = 'CheckBox';
export default CheckBox;
